import { AppointmentExchangeOfferResponse, AppointmentExchangeOfferStatus } from "@/api";

export interface PartitionedOffers {
  /** Offers the requester still has to decide on, oldest first. */
  pending: AppointmentExchangeOfferResponse[];
  /** Decided offers for the "Erledigt" section: the accepted one first, then the rejected ones, oldest first. */
  processed: AppointmentExchangeOfferResponse[];
}

const PROCESSED_RANK: Partial<Record<AppointmentExchangeOfferStatus, number>> = {
  [AppointmentExchangeOfferStatus.Accepted]: 0,
  [AppointmentExchangeOfferStatus.Rejected]: 1,
};

const byCreation = (a: AppointmentExchangeOfferResponse, b: AppointmentExchangeOfferResponse) =>
  a.createdAtUtc.getTime() - b.createdAtUtc.getTime();

/** Splits the offers into the two sections of the overlay; withdrawn offers are not shown at all. */
export function partitionOffers(offers: AppointmentExchangeOfferResponse[]): PartitionedOffers {
  const pending = offers.filter((offer) => offer.status === AppointmentExchangeOfferStatus.Pending).sort(byCreation);
  const processed = offers
    .filter((offer) => offer.status in PROCESSED_RANK)
    .sort((a, b) => (PROCESSED_RANK[a.status] ?? 0) - (PROCESSED_RANK[b.status] ?? 0) || byCreation(a, b));
  return { pending, processed };
}

/** Avatar text for the offering colleague, e.g. "MM"; falls back to the Kürzel when no name is known. */
export function counselorInitials(counselor: { firstName: string; lastName: string; userCode: string }): string {
  const initials = `${counselor.firstName.trim().charAt(0)}${counselor.lastName.trim().charAt(0)}`.toUpperCase();
  return initials || counselor.userCode.slice(0, 3).toUpperCase();
}
